import RepaymentSuccessScreen from 'features/lineOfCredit/screens/repaymentSuccessScreen/RepaymentSuccessScreen';
import React from 'react';

export default function Page() {
  return <RepaymentSuccessScreen />;
}
